import axios from 'axios'
import { Toast, Dialog } from 'vant'
import Cookies from 'js-cookie'
import router from '../router'

console.log(process.env.VUE_APP_BASE_API)

// create an axios instance
const service = axios.create({
  baseURL: (process.env.VUE_APP_BASE_API),
  // baseURL: 'http://nnh.letuy.cn/index.php/',
  // headers: {
  //   post: {
  //     'Content-Type': 'application/x-www-form-urlencoded'
  //   }
  // },
  timeout: 100000
})

// http request 拦截器
service.interceptors.request.use(
  config => {
    // 发送请求之前做一些处理
    const token = Cookies.get('token')
    if (token) {
      config.headers['Authorization'] = token
    }
    return config
  }, error => {
    // 当请求异常时做一些处理
  return Promise.reject(error)
})

// http response 拦截器
service.interceptors.response.use((response, promise) => {
  if (response.status === 200 && typeof response.headers.authorization !== 'undefined') {
    Cookies.set('token', response.headers.authorization)
  }
  return Promise.resolve(response.data)
}, (err, promise) => {
  if (!err.response) {
    // 断网了
    console.log(err.config)
    /*if (err.config.method === 'post') {
      Dialog.confirm({
        title: '请求失败',
        message: '数据提交失败，是否存档到手机！'
      }).then(() => {
        // on confirm
        let key = 'repost_' + Number(Math.random().toString().substr(3, 3) + Date.now()).toString(36)
        let repostArr =  JSON.parse(localStorage.getItem('repost_keys'))
        console.log(repostArr)
        if(!repostArr){
          repostArr = []
        }
        repostArr.push(key)
        localStorage.setItem('repost_keys',JSON.stringify(repostArr))
        localStorage.setItem(key,JSON.stringify(err.config))
        Toast('存档成功')
      }).catch(() => {
        // on cancel
      });
    }*/
  }
  if (err.response.status === 401) {
    // console.log(err.response.data.message);
    Toast({
      message: err.response.data.message,
      type: 'fail'
    })
    router.push({path: '/login'})
  } else if (err.response.status === 422) {
    for (let i in err.response.data.errors) {
      Toast({
        message: err.response.data.errors[i],
        type: 'fail'
      })
    }
  } else if (err.response.status === 500) {
    Toast('服务器开小差')
  } else {
    if (err.response.status !== 200) {
      Toast(err.response.data.message)
    }
  }
  return Promise.reject(err)
})

export default service
